// This file just converts types
import * as components from './components';
var _Field = components.Field, _ArrayField = components.ArrayField, _FormConsumer = components.FormConsumer, _FormProvider = components.FormProvider, _ObjectField = components.ObjectField, _RecursionField = components.RecursionField, _VoidField = components.VoidField, _createSchemaField = components.createSchemaField;
var Field = _Field;
var ArrayField = _ArrayField;
var ObjectField = _ObjectField;
var VoidField = _VoidField;
var RecursionField = _RecursionField;
var FormConsumer = _FormConsumer;
var FormProvider = _FormProvider;
var createSchemaField = _createSchemaField;
export { Field, ArrayField, ObjectField, VoidField, RecursionField, FormConsumer, FormProvider, createSchemaField, };
//# sourceMappingURL=vue2-components.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vue/esm/vue2-components.js
// module id = null
// module chunks = 